<template>
  <div class="headsupdisplay">

    <!-- <div id="game-layer" v-if="game">
      <iframe src="https://pixeldev.ca/proof/tree-prototype-3/" width="400" height="300"></iframe>
    </div> -->
    <!-- <div class="pageNum">Page {{ pageNum }} : Scene {{ sceneNum }}<p class="debugAltText">{{ sceneData.alt }}</p></div> -->
    <div class="pseudo-bgimg" role="img" :aria-label="sceneData.alt" tabindex="-1"></div>
    <div class="hud" v-if="controls">
      <div class="hud-content">
        <div id="narrator" class="narrator" v-if="sceneData.narrator" v-html="sceneData.narrator"></div>
        <div class="stats" v-if="sceneData.stats" v-html="sceneData.stats[0]" v-bind:class="{ statpos: statsIsLeft }"></div>
          <!--
            <div id="speech_bubble" class="speech-bubble round dialogue" v-if="sceneData.dialogue" :style="{ left: bubbleX + 'vw', bottom: bubbleY +'vh', transform: 'rotate(' + bubbleR + 'deg)'}" v-bind:class="{ techtalk: techTalking }">
            <div :style="textRotation" v-html="dialogueTxt"></div>
          -->
            <div id="speech_bubble" class="speech-bubble round dialogue" v-if="sceneData.dialogue" :style="{ left: bubbleX + 'vw', bottom: bubbleY +'vh'}" v-bind:class="{ techtalk: techTalking, right: bubbleArrowPosition == 1, left: bubbleArrowPosition == -1, happy: true, t: bubbleR == 180  }">
            <div style="textRotation" v-html="dialogueTxt"></div>
          </div>

        <div id="nav-controls">
          <div>
            <!-- <button class="nextBT btn-purple" @click="dialogueBack()" v-if="dialogueCount>0">{{ appData.back }}</button> -->
            <button class="nextBT btn-purple" @click="nextScene(0)" v-html="appData.next"></button>
          </div>
        </div>

      </div>
    </div>
    <div class="btn-gear-wrapper"><button id="gear" class="btn-gear hello"><img src="img/gear.svg" alt="Settings"></button></div>

  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'HeadsUpDisplay',
  // props: {
  //   appData: {
  //       type: Object
  //   }
  // },
  data() {
      return {
        language: 'E',
        controls: false,
        appData: {},
        sceneData: {},
        dialogueCount: 0,
        moreDialogue: false,
        dialogueTxt: "",
        mdial: "More",
        pageNum,
        currentScene: 0,
        sceneNum: 0,
        lastScene: false,
        comic: {},
        game: false,
        bubblePosition: [0,0,0],
        bubbleArrowPosition: 0,
        bubbleX: 0,
        bubbleY: 0,
        bubbleR: 0,
        desktopView: false,
        desktopOffset: 2,
        techTalking: false,
        statsIsLeft: false,
        audioState: null,
        audioToPlay: '',
        mobile: false,
        skipGames: false,
        resizing: false,
        autoplayState: false,
        isIOS: false
      }
    },
    beforeMount() {

      const urlParams = new URLSearchParams(window.location.search);
      let hhParam = urlParams.get('hh');
      if(hhParam == null){ hhParam = '1'; }

      // if(sessionStorage.getItem("lang") == null){
        //const param = urlParams.get('lang');
        // if(param == 'fr'){
        if(window.parent.document.documentElement.lang == 'fr-CA'){
          this.language = 'F'
          sessionStorage.setItem("lang", 'F');
        }else{
          sessionStorage.setItem("lang", 'E');
        }
      // }
      this.language = sessionStorage.getItem("lang");

      this.pageNum = Number(hhParam)
      this.comic = gsap.timeline()

      this.isIOS = (/iPad|iPhone|iPod/.test(navigator.platform) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
      !window.MSStream

      this.loadLanguage()

      //check if mobile


    },
    mounted() {

      if(this.language == 'F'){
        document.documentElement.lang = 'fr-ca'
      }else{
        document.documentElement.lang = 'en-ca'
      }
      
      this.audioState = sessionStorage.getItem("audioState");
      if(sessionStorage.getItem("autoplay") != null){
        this.autoplayState = parent.getAutoplay() ? parent.getAutoplay() : false //sessionStorage.getItem("autoplay");
      }

      var that = this;

      if(window.innerWidth > 600){
        this.desktopView = true;
        this.desktopOffset = 2;
        //console.log('d',this.desktopOffset)
      }else{
        this.desktopOffset = 1;
        //console.log('m',this.desktopOffset)
        this.mobile = true
      }

      window.appHome = this; // reference so canvas calls can find Vue functions

      window.addEventListener('resize', function(event){
        that.resizeFN();
      });

      this.setSessionStorage()
      document.querySelector('.pseudo-bgimg').focus();

      var that = this
      setTimeout(function(){
        that.gaEvent("Start");
      },500)

    },
    methods: {
      gaEvent: function(chapterStatus){
        var gaPage = this.pageNum

        var chapterName = "";
        if(chapterStatus == "Start"){
          if(gaPage == 1){
            chapterName = "Chapter 1 - Home";
          }else if(gaPage == 2){
            chapterName = "Chapter 2 - Hanging out at the hideout";
          }else if(gaPage == 6){
              chapterName = "Chapter 3 - Dr. Disarray raises alarm";
            }else if(gaPage == 10){
              chapterName = "Chapter 4 - Heroes start hero-ing";
            }else if(gaPage == 13){
              chapterName = "Chapter 5 - Situation critical";
            // }else if(gaPage == 15){
            //   chapterName = "Atlas vs. Robots: Mini-game";
            // }else if(gaPage == 24){
            //   chapterName = "Maven rewires robot: Mini-game";
            }else if(gaPage == 32){
              chapterName = "Chapter 8 - Vortex and Maven team up";
            // }else if(gaPage == 32){
            //   chapterName = "Vortex dodges robots: Mini-game";
            }else if(gaPage == 34){
              chapterName = "Chapter 10 - Heroes face Dr. Disarray";
            }else if(gaPage == 39){
              chapterName = "Chapter 11 - Vortex to the rescue";
            }else if(gaPage == 43){
              chapterName = "Chapter 12 - The next day";
          }else{
            return;  
          }
        }else{
          if(gaPage == 1){
            chapterName = "Chapter 1 - Home";
          }else if(gaPage == 5){
            chapterName = "Chapter 2 - Hanging out at the hideout";
          }else if(gaPage == 9){
              chapterName = "Chapter 3 - Dr. Disarray raises alarm";
            }else if(gaPage == 12){
              chapterName = "Chapter 4 - Heroes start hero-ing";
            }else if(gaPage == 15){
              chapterName = "Chapter 5 - Situation critical";
            }else if(gaPage == 24){
               chapterName = "Chapter 6 - Atlas vs. Robots: Mini-game";
            }else if(gaPage == 31){
               chapterName = "Chapter 7 - Maven rewires robot: Mini-game";
            }else if(gaPage == 32){
              chapterName = "Chapter 8 - Vortex and Maven team up";
            }else if(gaPage == 33){
               chapterName = "Chapter 9 - Vortex dodges robots: Mini-game";
            }else if(gaPage == 38){
              chapterName = "Chapter 10 - Heroes face Dr. Disarray";
            }else if(gaPage == 42){
              chapterName = "Chapter 11 - Vortex to the rescue";
            }else if(gaPage == 45){
              chapterName = "Chapter 12 - The next day";
          }else{
            return;  
          }
        }

        var playbackVersion = "Standard";
        if(parent.getAutoplay()){
          playbackVersion = "Fast Track"
        }
        
        var ln = this.language
        if(ln == 'F'){
          ln = 'FR'
        }else{
          ln = 'EN'
        }

        // console.log('+++',chapterName,':',chapterStatus,'- Page:',gaPage)

        var dataLayer = window.dataLayer || [];
        dataLayer.push({
          'event': 'Healthy-Heroes_Chapters',
          'hh_activity': 'Healthy Heroes',
          'hh_chapter': chapterName, // (Chapter Name)
          'hh_lang': ln, // (EN / FR)
          'hh_version': playbackVersion, // (Fast Track / Standard)
          'hh_chapter_status': chapterStatus, // (Start / End)
        });

        // console.log('Chapter Analytics',dataLayer)

      },
      loadLanguage: function(){
        axios.get('data/healthy_heros-' + this.language +'.json')
        .then((response)=> {
            this.appData = response.data
            this.setSceneData()

        })
      },
      setSessionStorage: function(){
        sessionStorage.setItem("mobile", this.mobile);
        sessionStorage.setItem("lang", this.language);
      },
      setSceneData: function(){

        this.sceneData = this.appData['page' + this.pageNum]['s' + this.currentScene]
        this.dialogueCount = 0

        if(this.sceneData.dialogue){
          this.mdial = "More",
          this.dialogueTxt = this.sceneData.dialogue[this.dialogueCount][0]

          this.setBubblePos()
          if(this.sceneData.techtalk){
            this.techTalking = true
          }else{
            this.techTalking = false
          }
        }

        this.moreDialogue = false

        if(this.sceneData.dialogue){
          if(this.sceneData.dialogue.length > 1){
            this.moreDialogue = true
          }
        }

        if(this.sceneData.stats){
          if(this.sceneData.stats[1] == 'left'){
            this.statsIsLeft = true
          }else{
            this.statsIsLeft = false
          }
        }

        if(this.sceneNum > 0){
        // console.log('Page: '+ this.pageNum +' - Scene: ' + this.sceneNum,'\n',this.sceneData.alt)
        }

        // if(this.sceneData.sfx){
        //   window.parent.playSFX(this.sceneData.sfx);
        // }

        // this.sceneNum = 0
      },
      nextScene: function(val = 0){

        if(this.sceneData.sfx){
          window.parent.playSFX(this.sceneData.sfx);
        }

        // if(this.pageNum != 1 && this.sceneNum != 1){
        //   console.log('--- audio check ---')
        //   window.parent.checkAudioPlayback();
        // }

        if(this.moreDialogue){
          if(this.dialogueCount < this.sceneData.dialogue.length - 1){
            this.dialogueCount = this.dialogueCount + 1
            this.dialogueTxt = this.sceneData.dialogue[this.dialogueCount][0]

            this.setBubblePos()
            return;
          }
        }

        // if comic was not played from page 1, this checks to see what audio should play
        // sessionStorage allows the following pages to bypass this check
        if(this.pageNum > 1 && this.audioState == null){
          var pnm = 0;
          for (const i in this.appData) {
            if(i.slice(0,4) == 'page'){
              pnm++;
              for (const ii in this.appData[i]) {
                if(i == 'page' + this.pageNum && ii == 's1'){

                  if(!this.isIOS){
                    window.parent.playSound(this.audioToPlay);
                  }else{
                    if(this.sceneNum > 0){
                      window.parent.playSound(this.audioToPlay);
                    }else{
                      // console.log('iOS audio call - scene 0')
                    }
                  }
                  
                  sessionStorage.setItem("audioState", true);
                  this.audioState = true
                  break
                }
                for (const iii in this.appData[i][ii]) {
                  if(iii == 'audio'){
                    this.audioToPlay = this.appData[i][ii][iii]
                  }
                }
              }
            }
          }
        }else{
        // comic was played from page 1
          if(this.sceneData.audio){
            if(this.audioToPlay != this.sceneData.audio){
              this.audioToPlay = this.sceneData.audio

              if(!this.isIOS){
                window.parent.playSound(this.audioToPlay);
              }else{
                if(this.sceneNum > 0){
                  window.parent.playSound(this.audioToPlay);
                }else{
                  // console.log('iOS audio call - scene 0')
                }
              }
              
              sessionStorage.setItem("audioState", true)
              this.audioState = true
            }
          }
        }

        if(this.lastScene == true){
          // console.log('upcoming music',this.appData['page' + (this.pageNum + 1)].s0.audio)

          if(!this.sceneData.comicEnd){
            let nextPageAudio = this.appData['page' + (this.pageNum + 1)].s0.audio
            if(nextPageAudio != null && nextPageAudio != undefined){
              window.parent.playSound(nextPageAudio);
            }
          }

          this.lastScene = false
          this.nextPage()

          return;
        }

        this.sceneNum = Number(this.sceneNum) + 1

        if(this.sceneNum == Number(this.appData['page' + this.pageNum].totalScenes)){
          this.lastScene = true
        }

        this.game = false;
        this.controls = false;
        this.comic.to('.headsupdisplay', .1, {alpha:0})
        this.currentScene = this.appData['page' + this.pageNum]['s' + this.currentScene].goto[val]
        setValues(this.pageNum,this.currentScene)
        playAnima(); // canvasComm.js -- plays animate timeline
        //---
        this.setSceneData()

      },
      actionFN: function(){
        // if(this.sceneData.autoplay != null && this.autoplayState){
        if(this.sceneData.autoplay != null && parent.getAutoplay() ? parent.getAutoplay() : false){

          this.nextScene(0)
          return
        }
// console.log(this.sceneData.dialogue,this.sceneData.narrator,this.sceneData.stats,this.currentScene,Number(this.appData['page' + this.pageNum].totalScenes),this.sceneData.comicEnd)
        /*if(this.sceneData.dialogue == undefined && this.sceneData.narrator == undefined && this.sceneData.stats == undefined && this.currentScene != 0 && this.currentScene != Number(this.appData['page' + this.pageNum].totalScenes) && this.sceneData.comicEnd == undefined){
          this.nextScene(0)
          return
        }*/

        if(this.sceneData.type == 'intro'){
          this.nextScene(0)
        }else{
          if(this.sceneData.comicEnd){
            this.appData.next = this.appData.theend
            // window.parent.playSound('heroTheme');
          }
          this.controls = true
          this.comic.fromTo('.headsupdisplay', .5, {alpha:0},{alpha:1,ease:Power2.easeInOut})
        }
      },
      checkType: function(type){
        if(this.sceneData.type == type){
          return true
        }else {
          return false
        }
      },
      dialogueBack: function(){

        this.dialogueCount = this.dialogueCount - 1
        this.dialogueTxt = this.sceneData.dialogue[this.dialogueCount][0]

        this.setBubblePos()

      },
      nextPage: function(){

        this.gaEvent("End");

        if(this.sceneData.comicEnd){
          setNextPage('1')
          window.parent.stopSound()
          return
        }

        this.pageNum = this.pageNum + 1
        this.dialogueCount = 0

        if(this.sceneData.type == 'game' && !this.skipGames){
          loadGame(this.sceneData.goto, this.language)
          setValues(this.pageNum, this.currentScene)
          return
        }else if(this.sceneData.type == 'decision'){
          loadDecision(this.sceneData.goto, this.language)
          setValues(this.pageNum, this.currentScene)
          return
        }else if(this.sceneData.type == 'skip-page'){
          this.pageNum = this.sceneData.goto
        }

        setNextPage(this.pageNum)
        setValues(this.pageNum, this.currentScene)
      },
      // loadGame: function(val){
      //   this.game = true;
      // },
      setBubblePos: function(){
        if(this.sceneData.dialogue){
          // if(this.mobile){
          //   if(this.sceneData.dialogue[this.dialogueCount][2]){
          //     this.bubblePosition = this.sceneData.dialogue[this.dialogueCount][2]
          //   }else{
          //     this.bubblePosition = this.sceneData.dialogue[this.dialogueCount][1]
          //   }
          // }else{
          //   this.bubblePosition = this.sceneData.dialogue[this.dialogueCount][1]
          // }

          this.bubblePosition = this.sceneData.dialogue[this.dialogueCount][1]
          if (window.innerWidth > 799) {
            this.bubblePosition = this.sceneData.dialogue[this.dialogueCount][1]
            if (document.body.classList.contains('large')) {
              this.bubbleX = this.bubblePosition[4] ? this.bubblePosition[4] : this.bubblePosition[0]
              this.bubbleY = (this.bubblePosition[5] ? this.bubblePosition[5] : this.bubblePosition[1]) + this.desktopOffset
              this.bubbleR = this.bubbleR = this.bubblePosition[6] ? this.bubblePosition[6] : this.bubblePosition[2]
            } else {
              this.bubbleX = this.bubblePosition[0]
              this.bubbleY = this.bubblePosition[1] + this.desktopOffset
              this.bubbleR = this.bubblePosition[2]
            }
          } else {
            this.bubblePosition = this.bubblePosition = this.sceneData.dialogue[this.dialogueCount][2] ? this.sceneData.dialogue[this.dialogueCount][2] : this.bubblePosition = this.sceneData.dialogue[this.dialogueCount][1]
            this.bubbleArrowPosition = this.bubblePosition[3] ? this.bubblePosition[3] : 0
            if (document.body.classList.contains('large')) {
              this.bubbleX = this.bubblePosition[4] ? this.bubblePosition[4] : this.bubblePosition[0]
              this.bubbleY = this.bubblePosition[5] ? this.bubblePosition[5] : this.bubblePosition[1]
              this.bubbleR = this.bubblePosition[6] ? this.bubblePosition[6] : this.bubblePosition[2]
            } else {
              this.bubbleX = this.bubblePosition[0]
              this.bubbleY = this.bubblePosition[1]
              this.bubbleR = this.bubblePosition[2]

            }

          }
          if(this.dialogueCount >= 1){
            var slideDir = -5
            if(this.bubblePosition[2] == '180'){
              slideDir = 5
            }
            if(this.resizing == false){
              this.comic.fromTo('.dialogue', .5, {alpha:0,y:slideDir},{alpha:1,y:0})
            }
            this.resizing = false
          }
        }
        // this.bubbleR = this.bubblePosition[2]
      },
      resizeFN: function(){
        if(window.innerWidth > 799){
        // if(window.getComputedStyle(document.getElementById('desktop-indicator')).display === 'block'){
          this.desktopView = true;
          this.desktopOffset = 2;
        }else{
          this.desktopOffset = 0; //1;
        }
        if(this.sceneData != null){
          this.resizing = true
          this.setBubblePos()
        }
      },
      showHud: function(){
        this.controls = true
        this.comic.fromTo('.headsupdisplay', .5, {alpha:0},{alpha:1,ease:Power2.easeInOut})
      }
    },
    computed: {
      textRotation () {
        var rt = this.bubbleR
        return { transform: 'rotate(' + rt + 'deg)' }
      }
    }
}
</script>

<style lang="scss" scoped>

.debugAltText{
  font-size:.6rem;
  line-height:.7rem;
}

.headsupdisplay {
  opacity: 0;
}
.hud {
  margin-top:25%;

  @media only screen and (max-width: 600px) {
    margin-top: 0%;
  }
}

hud-content{
  position: relative;
}

.btn-purple {
  font-family: "Outfit", sans-serif;
  border-radius: 30px;
  padding: .6rem 3rem;
  color: white;
  background: #68277E;
  border: 3px solid black;
  box-shadow: 3px 3px 14px 1px rgba(0, 0, 0, 0.4);
}

.btn-purple:hover {
  /* border-color: aqua; */
  background: white;
  color: #68277E;
}

.nextBT{
  font-size: 1.25rem;
  font-weight: 700;
  display: block;
  margin-top: 10px;
  // float: right;
}

// .buttonSmall{
//   width: 40px;
//   margin: 10px auto;
//   position: absolute;
//   bottom: -40px;
//   right: 0px;
// }

.narrator {
  font-size: 1rem;
  line-height: 1.4;
  font-weight: 700;
  position: absolute;
  top: calc(25vh + 10px);
  left: 10px;
  // max-width: 60%;ß
  padding: 1rem 1.25rem;
  // padding-right: 60px;
  background: lightgoldenrodyellow;
  color: black;
  border: 4px solid black;
  border-top: 0;
  border-left: 0;
  text-align: left;
  box-shadow: 3px 3px 14px 1px rgba(0, 0, 0, 0.4);
  max-width: 60%;
  // @media only screen and (max-width: 600px) {
  //   top: 10px;
  // }
  // @media only screen and (max-width: 799px) {
  //   top: 10px;
  //   max-width: none;
  //   padding: 1rem;
  //   min-width: 60vw;
  // }
}

body.mobile .narrator {
  top: 10px;
  max-width: none;
  padding: 1rem;
  min-width: 60vw;
}

.stats {
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 2rem;
  position: absolute;
  bottom: 48vh;
  right: 10px;
  padding: 1.5rem;
  background: black;
  color: white;
  border: 4px double white;
  border-right: 0;
  text-align: left;
  box-shadow: 3px 3px 14px 1px rgba(0, 0, 0, 0.4);
  max-width: 60%;
  min-width: 40%;
  z-index: 1499;
}

.statpos{
  right: unset;
  left: 10px;
  border-right: 4px double white;
  border-left: 0;
}

.dialogue {
  // width: 150px;
  // border: 2px solid black;
  // border-radius: 20px;
  // background: white;
  // color: black;
  // padding: 5px;

  position: absolute !important;
  bottom: 0%;
  left: 0%;
}

.techtalk {
  // background: linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(225,255,255,1) 25%, rgba(225,255,255,1) 75%, rgba(255,255,255,1) 100%);
  --border-color: red;
}

#nav-controls {
  position: absolute;
  bottom: calc(25% + 40px);
  bottom: calc(25% + 10px + 0.625rem);
  right: 40px;
  right: calc(10px + 0.875rem);
  // width: 1px;

  // @media only screen and (max-width: 799px) {
  //   bottom: 20px;
  //   right: 20px;
  // }
}

body.mobile #nav-controls {
  bottom: 20px;
  right: 20px;
}

#game-layer {
  position: absolute;
  top: calc(25% + 10px);
  left: 10px;
  z-index: 2000;
}

#game-layer iframe{
  width: 800px;
  height: 600px;
}

.pageNum{
  padding: 15px;
  background: white;
  color: black;
  position: absolute;
  bottom: 25%;
  left: 10%;
  z-index: 9999;
  width: 65%;
  // @media only screen and (max-width: 799px) {
  //   bottom: 10px;
  //   width: 40%;
  //   left: 10%;
  // }
}
body.mobile .pageNum {
  bottom: 10px;
  width: 40%;
  left: 10%;
}

.btn-gear {
  bottom: calc(25% + 40px);
  bottom: calc(25% + 10px + 0.625rem);
  position: absolute;
  left: 40px;
  left: calc(10px + 0.875rem);
  padding: 0;
  border: 0;
  // @media only screen and (max-width: 799px) {
  //   left: 20px;
  //   bottom: 20px;
  // }
}

body.mobile .btn-gear {
  left: 20px;
  bottom: 20px;
}

</style>
